/**
 * jqueryの予測変換プラグインに若干手を加えています。
 * 40～47行目	サジェストリストにフォーカスが当たっている時はリストを消さない（スクロールバーをクリックすると消えていたため。）
 * 121～135行目	入力フォームにフォーカスが当たったらリストの表示、フォーカスが外れてもリストにフォーカスしていたらリストを消さない
 * 340行目		clickAddMethodオプションの追加　リストをクリックした時に追加で別の関数を呼べるように改修
 * 26、512行目	minWidthオプションの追加　サジェストリストの横幅の最低値を指定できるように改修
 * 
 * 2016/11 古屋追記
 * 25～46行目		tplにid="ac_results_id"の要素を設定することで、サジェストリスト用のdivをあらかじめ作成できるように改修
 * 405～417行目	clickAddMethodが登録されていれば発行するが、そのときにクリック以降のイベントを殺しているので
 * 						リスト内にaタグがある場合に遷移しなくなる。ので、clickAddMethodがない場合は殺さないように修正。
 * parseData		options.listValueで値を外から設定するように改修
 * dataToDom		li.id→options.listID, li.innerHTML→options.listInnerHTML, li.selectValue→options.listValueと、値を外から設定するように改修
 * 上記3点の改修でPC用サジェストリストライブラリとして汎化。
 * 
 * 【使い方】
 * １．該当ページで本jsを読み込む。
 * ２．該当ページのjsに以下を記載する。
 * 	var textBox = $("#textbox"); // サジェスト用テキストボックスを取得
 * 	option = {
 * 			// 必須
 * 			minChars : 2,// 何文字からサジェストを始めるか
 * 			minWidth : 235,// サジェストリストの最低横幅を決める
 * 			listID : function(data){return data['Station']['id'];}, // 各サジェスト候補のID（dataにはJSONで取得してきた値が入っている）
 * 			listInnerHTML : function(data){return data['Station']['name'];}, // リスト内部のHTML（dataにはJSONで取得してきた値が入っている）
 * 			listValue : function(data){return data['Station']['name']} // リストのvalue（dataにはJSONで取得してきた値が入っている）
 * 			// オプション
 * 			extraParams : {'pref_cd' : $('input[name=pref_cd]').val()},// テキストボックスの入力内容に加えてJSONで渡したいパラメータ
 * 	}
 * 	textBox.autocomplete('/station/get_autocomplete_json/',option); // 左記のとおり、サジェスト取得用URL、optionsの順で設定する
 *  ３．もし、サジェストアイテムに対してGAのイベントタグを設定したい場合は、
 *  		tplに<div id="ac_results_id"/>を作成し、そこにイベントタグをしこめばＯＫ。
 *  		特に何もない場合は<div id="ac_results_id"/>は不要。勝手に作ってくれる。
 *  
 * プラグイン発行元
 * http://www.pengoworks.com/workshop/jquery/autocomplete.htm
**/
//予測変換
jQuery.autocomplete = function(input, options) {
	// Create a link to self
	var me = this;

	// Create jQuery object for input element
	var $input = $(input).attr("autocomplete", "off");

	// Apply inputClass if necessary
	if (options.inputClass) $input.addClass(options.inputClass);

	// 下記div新規作成フラグ
	var createdDiv = false;
	// サジェスト候補にGAのイベントタグを設定したい場合などは
	// tplに候補リストを格納する先を記載する
	var results = $('#ac_results_id')[0];
	if (results == undefined) {
		// 上記要素がなければ新規作成する
		results = document.createElement("div");
		createdDiv = true;
	}
	// Create jQuery object for results resultsオブジェクトの中にサジェスト表示領域を作成
	var $results = $(results);
	$results.hide().addClass(options.resultsClass).css("position", "absolute");
	if (createdDiv) {
		$results.attr("id",options.resultsClassId);
	}
	if( options.width > 0 ) $results.css("width", options.width);
	if( options.minWidth > 0) $results.css("min-width",options.minWidth);

	// Add to body element resultsオブジェクトをbody内に反映
	if (createdDiv) {
		$("body").append(results);
	}

	input.autocompleter = me;

	var timeout = null;
	var prev = "";
	var active = -1;
	var cache = {};
	var keyb = false;
	var hasFocus = false;
	var lastKeyPressCode = null;
	var suggest_selecting = false;

	//サジェスト表示領域にマウスがある間は表示を消さない
	$("#"+options.resultsClassId).hover(function () {
		suggest_selecting = true;
	}, function () {
		suggest_selecting = false;
		//入力フォームからフォーカスが外れていたらサジェストリストを消す
		if(!hasFocus)hideResults();
	});

	// flush cache
	function flushCache(){
		cache = {};
		cache.data = {};
		cache.length = 0;
	};

	// flush cache
	flushCache();

	// if there is a data array supplied
	if( options.data != null ){
		var sFirstChar = "", stMatchSets = {}, row = [];

		// no url was specified, we need to adjust the cache length to make sure it fits the local data store
		if( typeof options.url != "string" ) options.cacheLength = 1;

		// loop through the array and create a lookup structure
		for( var i=0; i < options.data.length; i++ ){
			// if row is a string, make an array otherwise just reference the array
			row = ((typeof options.data[i] == "string") ? [options.data[i]] : options.data[i]);

			// if the length is zero, don't add to list
			if( row[0].length > 0 ){
				// get the first character
				sFirstChar = row[0].substring(0, 1).toLowerCase();
				// if no lookup array for this character exists, look it up now
				if( !stMatchSets[sFirstChar] ) stMatchSets[sFirstChar] = [];
				// if the match is a string
				stMatchSets[sFirstChar].push(row);
			}
		}

		// add the data items to the cache
		for( var k in stMatchSets ){
			// increase the cache size
			options.cacheLength++;
			// add to the cache
			addToCache(k, stMatchSets[k]);
		}
	}

	//入力フォームでのイベント
	$input
	.keydown(function(e) {
		// track last key pressed
		lastKeyPressCode = e.keyCode;
		switch(e.keyCode) {
			case 38: // up
				e.preventDefault();
				moveSelect(-1);
				break;
			case 40: // down
				e.preventDefault();
				moveSelect(1);
				break;
			case 9:  // tab
			case 13: // return
				if( selectCurrent() ){
					// make sure to blur off the current field
					//$input.get(0).blur();
					e.preventDefault();
				}
				break;
			default:
				active = -1;
				if (timeout) clearTimeout(timeout);
				timeout = setTimeout(function(){onChange();}, options.delay);
				break;
		}
	})
	//firefoxのみ日本語入力時に全てのキーイベントを取得しない＋変換後のEnterはonkeyupでしかイベントが走らないのでそれらの対応
	.keyup(function(e){
		var userAgent = window.navigator.userAgent.toLowerCase();
		if (userAgent.indexOf("firefox") > -1) {
			lastKeyUpCode = e.keyCode;
			switch(e.keyCode) {
			case 38: // up
				e.preventDefault();
				moveSelect(-1);
				break;
			case 40: // down
				e.preventDefault();
				moveSelect(1);
				break;
			case 9:  // tab
		/*	case 13: // return
				if( selectCurrent() ){
					// make sure to blur off the current field
					//$input.get(0).blur();
					e.preventDefault();
				}
				break;*/
			default:
				active = -1;
				if (timeout) clearTimeout(timeout);
				timeout = setTimeout(function(){onChange();}, options.delay);
				break;
			}
		}
	})
	//フォーカスが当たった時はサジェスト表示領域を更新する
	.focus(function(){
		// track whether the field has focus, we shouldn't process any results if the field no longer has focus
		hasFocus = true;
		suggest_selecting = false;
		onChange();
	})
	//フォーカスが外れた時にサジェスト表示領域を消す
	.blur(function() {
		// track whether the field has focus
		hasFocus = false;
		//サジェスト表示領域にマウスがなかったらサジェストリストを消す
		if(!suggest_selecting) hideResults();
	});

	hideResultsNow();

	function onChange() {
		// ignore if the following keys are pressed: [del] [shift] [capslock]
		if( lastKeyPressCode == 46 || (lastKeyPressCode > 8 && lastKeyPressCode < 32) ) return $results.hide();
		var v = $input.val();
		//if (v == prev) return; //入力されている項目が更新されてなかったらフォーカスが向いてもリストを表示しない。
		prev = v;
		if (v.length >= options.minChars) {
			$input.addClass(options.loadingClass);
			requestData(v);
		} else {
			$input.removeClass(options.loadingClass);
			$results.hide();
		}
	};

 	function moveSelect(step) {

		var lis = $("li", results);
		if (!lis) return;

		active += step;

		if (active < 0) {
			active = 0;
		} else if (active >= lis.size()) {
			active = lis.size() - 1;
		}

		lis.removeClass("ac_over");

		$(lis[active]).addClass("ac_over");

		// Weird behaviour in IE
		// if (lis[active] && lis[active].scrollIntoView) {
		// 	lis[active].scrollIntoView(false);
		// }

	};

	function selectCurrent() {
		var li = $("li.ac_over", results)[0];
		if (!li) {
			var $li = $("li", results);
			if (options.selectOnly) {
				if ($li.length == 1) li = $li[0];
			} else if (options.selectFirst) {
				li = $li[0];
			}
		}
		if (li) {
			$(li).click();
			return true;
		} else {
			return false;
		}
	};

	function selectItem(li) {
		if (!li) {
			li = document.createElement("li");
			li.extra = [];
			li.selectValue = "";
		}
		var v = $.trim(li.selectValue ? li.selectValue : li.innerHTML);
		input.lastSelected = v;
		prev = v;
		$results.html("");
		$input.val(v);
		hideResultsNow();
		if (options.onItemSelect) setTimeout(function() { options.onItemSelect(li) }, 1);
	};

	// selects a portion of the input string
	function createSelection(start, end){
		// get a reference to the input element
		var field = $input.get(0);
		if( field.createTextRange ){
			var selRange = field.createTextRange();
			selRange.collapse(true);
			selRange.moveStart("character", start);
			selRange.moveEnd("character", end);
			selRange.select();
		} else if( field.setSelectionRange ){
			field.setSelectionRange(start, end);
		} else {
			if( field.selectionStart ){
				field.selectionStart = start;
				field.selectionEnd = end;
			}
		}
		field.focus();
	};

	// fills in the input box w/the first match (assumed to be the best match)
	function autoFill(sValue){
		// if the last user key pressed was backspace, don't autofill
		if( lastKeyPressCode != 8 ){
			// fill in the value (keep the case the user has typed)
			$input.val($input.val() + sValue.substring(prev.length));
			// select the portion of the value not typed by the user (so the next character will erase)
			createSelection(prev.length, sValue.length);
		}
	};

	function showResults() {
		// get the position of the input field right now (in case the DOM is shifted)
		var pos = findPos(input);
		// either use the specified width, or autocalculate based on form element
		var iWidth = (options.width > 0) ? options.width : $input.width();
		// reposition
		$results.css({
			//width: parseInt(iWidth) + "px", //幅が入力フォームの幅or固定値で決めるしかないので中の文字列で可変するように指定を外す
			top: (pos.y + input.offsetHeight) + "px",
			left: pos.x + "px"
		}).show();
	};

	function hideResults() {
		if (timeout) clearTimeout(timeout);
		timeout = setTimeout(hideResultsNow, 200);
	};

	function hideResultsNow() {
		if (timeout) clearTimeout(timeout);
		$input.removeClass(options.loadingClass);
		if ($results.is(":visible")) {
			$results.hide();
		}
		if (options.mustMatch) {
			var v = $input.val();
			if (v != input.lastSelected) {
				selectItem(null);
			}
		}
	};

	function receiveData(q, data) {
		if (data) {
			$input.removeClass(options.loadingClass);
			results.innerHTML = "";

			// if the field no longer has focus or if there are no matches, do not display the drop down
			if( !hasFocus || data.length == 0 ) {
				if (options.emptyListInnerHTML != null) {
					results.appendChild(options.emptyListInnerHTML());
					showResults();
					return;
				} else {
					return hideResultsNow();
				}
			}

			if (/*@cc_on!@*/false) {
				// we put a styled iframe behind the calendar so HTML SELECT elements don't show through
				$results.append(document.createElement('iframe'));
			}
			results.appendChild(dataToDom(data));
			// autofill in the complete box w/the first match as long as the user hasn't entered in more data
			if( options.autoFill && ($input.val().toLowerCase() == q.toLowerCase()) ) autoFill(data[0][0]);
			showResults();
		} else {
			hideResultsNow();
		}
	};

	function parseData(data) {
		if (!data) return null;
		var parsed = [];
		var rows = data;
		for (var i=0; i < rows.length; i++) {
			var row = rows[i];
			if (row) {
				parsed[parsed.length] = options.listValue(row);
			}
		}
		return parsed;
	};

	function dataToDom(data) {
		var ul = document.createElement("ul");
		var num = data.length;

		// limited results to a max number
		if( (options.maxItemsToShow > 0) && (options.maxItemsToShow < num) ) num = options.maxItemsToShow;

		for (var i=0; i < num; i++) {
			var row = data[i];
			if (!row) continue;
			var li = document.createElement("li");
			if (options.formatItem) {
				li.innerHTML = options.formatItem(row, i, num);
				li.selectValue = row[0];
			} else {
				li.id = options.listID(row);
				li.innerHTML = options.listInnerHTML(row);
				li.selectValue = options.listValue(row);
			}
			var extra = null;
			if (row.length > 1) {
				extra = [];
				for (var j=1; j < row.length; j++) {
					extra[extra.length] = row[j];
				}
			}
			li.extra = extra;
			ul.appendChild(li);
			$(li).hover(
				function() { $("li", ul).removeClass("ac_over"); $(this).addClass("ac_over"); active = $("li", ul).indexOf($(this).get(0)); },
				function() { $(this).removeClass("ac_over"); }
			).click(function(e) { selectItem(this); options.clickAddMethod(this); });
		}
		return ul;
	};

	function requestData(q) {
		if (!options.matchCase) q = q.toLowerCase();
		var data = options.cacheLength ? loadFromCache(q) : null;
		// recieve the cached data キャッシュの情報を送る
		if (data) {
			receiveData(q, data);
		// if an AJAX url has been supplied, try loading the data now GETメソッドを使ってphpから値を取得
		} else if( (typeof options.url == "string") && (options.url.length > 0) ){
			$.getJSON(makeUrl(q), function(data){
				def_data = data.list;
				data = parseData(data.list);
				addToCache(q, data);
				receiveData(q, def_data);
			});
		// if there's been no data found, remove the loading class 値が無くなった場合は表示領域をクリアする
		} else {
			$input.removeClass(options.loadingClass);
		}
	};

	function makeUrl(q) {
		var url = options.url + "?suggest_word=" + encodeURI(q);//GET時にわかりやすいように取得する変数を「suggest_word」に変更
		//もしオプションで別のパラメータを指定していた場合は&でサジェストワードの後ろに接続
		for (var i in options.extraParams) {
			url += "&" + i + "=" + encodeURI(options.extraParams[i]);
		}
		return url;
	};

	function loadFromCache(q) {
		if (!q) return null;
		if (cache.data[q]) return cache.data[q];
		if (options.matchSubset) {
			for (var i = q.length - 1; i >= options.minChars; i--) {
				var qs = q.substr(0, i);
				var c = cache.data[qs];
				if (c) {
					var csub = [];
					for (var j = 0; j < c.length; j++) {
						var x = c[j];
						var x0 = x[0];
						if (matchSubset(x0, q)) {
							csub[csub.length] = x;
						}
					}
					return csub;
				}
			}
		}
		return null;
	};

	function matchSubset(s, sub) {
		if (!options.matchCase) s = s.toLowerCase();
		var i = s.indexOf(sub);
		if (i == -1) return false;
		return i == 0 || options.matchContains;
	};

	this.flushCache = function() {
		flushCache();
	};

	this.setExtraParams = function(p) {
		options.extraParams = p;
	};

	this.findValue = function(){
		var q = $input.val();

		if (!options.matchCase) q = q.toLowerCase();
		var data = options.cacheLength ? loadFromCache(q) : null;
		if (data) {
			findValueCallback(q, data);
		} else if( (typeof options.url == "string") && (options.url.length > 0) ){
			$.get(makeUrl(q), function(data) {
				data = parseData(data)
				addToCache(q, data);
				findValueCallback(q, data);
			});
		} else {
			// no matches
			findValueCallback(q, null);
		}
	}

	function findValueCallback(q, data){
		if (data) $input.removeClass(options.loadingClass);

		var num = (data) ? data.length : 0;
		var li = null;

		for (var i=0; i < num; i++) {
			var row = data[i];

			if( row[0].toLowerCase() == q.toLowerCase() ){
				li = document.createElement("li");
				if (options.formatItem) {
					li.innerHTML = options.formatItem(row, i, num);
					li.selectValue = row[0];
				} else {
					li.innerHTML = row[0];
					li.selectValue = row[0];
				}
				var extra = null;
				if( row.length > 1 ){
					extra = [];
					for (var j=1; j < row.length; j++) {
						extra[extra.length] = row[j];
					}
				}
				li.extra = extra;
			}
		}

		if( options.onFindValue ) setTimeout(function() { options.onFindValue(li) }, 1);
	}

	function addToCache(q, data) {
		if (!data || !q || !options.cacheLength) return;
		if (!cache.length || cache.length > options.cacheLength) {
			flushCache();
			cache.length++;
		} else if (!cache[q]) {
			cache.length++;
		}
		cache.data[q] = data;
	};

	function findPos(obj) {
		var curleft = obj.offsetLeft || 0;
		var curtop = obj.offsetTop || 0;
		while (obj = obj.offsetParent) {
			curleft += obj.offsetLeft
			curtop += obj.offsetTop
		}
		return {x:curleft,y:curtop};
	}
}

jQuery.fn.autocomplete = function(url, options, data) {
	// Make sure options exists
	options = options || {};
	// Set url as option
	options.url = url;
	// set some bulk local data
	options.data = ((typeof data == "object") && (data.constructor == Array)) ? data : null;

	// Set default values for required options
	options.inputClass = options.inputClass || "ac_input";
	options.resultsClass = options.resultsClass || "ac_results";
	options.lineSeparator = options.lineSeparator || "\n";
	options.cellSeparator = options.cellSeparator || "|";
	options.minChars = options.minChars || 1;
	options.delay = options.delay || 400;
	options.matchCase = options.matchCase || 1;
	options.matchSubset = options.matchSubset || 1;
	options.matchContains = options.matchContains || 0;
	options.cacheLength = options.cacheLength || 0;
	options.mustMatch = options.mustMatch || 0;
	options.extraParams = options.extraParams || {};
	options.loadingClass = options.loadingClass || "ac_loading";
	options.selectFirst = options.selectFirst || false;
	options.selectOnly = options.selectOnly || false;
	options.maxItemsToShow = options.maxItemsToShow || -1;
	options.autoFill = options.autoFill || false;
	options.width = parseInt(options.width, 10) || 0;
	options.resultsClassId = options.resultsClassId || "ac_results_id";
	options.clickAddMethod = options.clickAddMethod || null;//リストの項目をクリック時に追加で起動させるイベント
	options.minWidth = options.minWidth || 0;
	options.formatItem = options.formatItem || false;
	options.listID = options.listID || function(){};
	options.listInnerHTML = options.listInnerHTML || function(){return ''};
	options.listValue = options.listValue || function(){};
	options.emptyListInnerHTML = options.emptyListInnerHTML || null;

	this.each(function() {
		var input = this;
		new jQuery.autocomplete(input, options);
	});

	// Don't break the chain
	return this;
}

jQuery.fn.autocompleteArray = function(data, options) {
	return this.autocomplete(null, options, data);
}

jQuery.fn.indexOf = function(e){
	for( var i=0; i<this.length; i++ ){
		if( this[i] == e ) return i;
	}
	return -1;
};
